import React from "react";

//components
import { BasicTextInput } from "thrive-components";

//interfaces
import { IFormTextInput } from "../../../interfaces/FormInputs";



const FormTextInput = ({
    id,
    label,
    value,
    setValue,
    errorMessage,
    onBlur,
    type,
    showError,
    placeholder = ""
}: IFormTextInput) => {

    return (
        <div className="input-wrapper">
            <BasicTextInput
                id={id}
                labelText={label}
                placeholderText={placeholder}
                textString={value}
                setTextString={setValue}
                type={type || "text"}
                className={showError ? "error-styling" : ""}
                onBlur={onBlur}
                maxLength={265}
            />

            {showError && (
                <span className="error-indicator">
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

export default FormTextInput;